export const Logo = ({ className = "", size = "md" }) => {
  const h = size === "sm" ? "h-9" : "h-14";
  return (
    <img
      src="/konattu-logo.png"
      alt="Konattu Group"
      className={`${h} w-auto block ${className}`}
      data-testid="konattu-logo"
    />
  );
};

export default Logo;
